<template>
  <div v-if="quotation.actions">
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <!-- 明细 -->
      <v-tooltip top v-if="showView && $permission.permissionAllow('Quotations', 'view')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            :href="'/#/quotations/' +
              quotation.id
            "
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("Quotations.actions.detail") }}
          </v-btn>
        </template>
        <span>{{
          $t("CRUD.viewInfo", [$t("Quotations.ObjectName")])
        }}</span>
      </v-tooltip>
      <!-- 确认 -->
      <v-tooltip top v-if="showConfirm && $permission.permissionAllow('Quotations', 'confirm')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            v-bind="attrs"
            v-on="on"
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                $router.push('/quotations/' + quotation.id + '/confirm');
              })
            "
          >
            <v-icon x-small class="pe-1">fa-location-arrow</v-icon>
            {{ $t("Quotations.actions.confirm") }}
          </v-btn>
        </template>
        <span>{{
          $t("CRUD.editInfo", [$t("Quotations.ObjectName")])
        }}</span>
      </v-tooltip>
      <!-- 审批 -->
      <v-tooltip
        top
        v-if="
          showApprove &&
          $permission.permissionAllow('Quotations', 'approve')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="action"
            class="px-2 me-2 mb-1"
            @click.stop="
            $permission.checkAccountExpired().then(() => {
                $router.push('/quotations/' + quotation.id + '/approve');
              })"
          >
            <v-icon x-small class="pe-1">fa-stamp</v-icon>
            {{
              $t("Quotations.actions.approve"
              )
            }}
          </v-btn>
        </template>
        <span>{{ $t("Quotations.actions.approve") }}</span>
      </v-tooltip>
      <!-- 作废 -->
      <v-tooltip top v-if="showCancel && $permission.permissionAllow('Quotations', 'cancel')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            v-bind="attrs"
            v-on="on"
            dark
            color="danger"
            class="px-2 me-2 mb-1"
            @click.stop="cancelAlert = true"
          >
            <v-icon x-small class="pe-1">fa-exclamation</v-icon>
            {{ $t("Quotations.actions.cancel") }}
          </v-btn>
        </template>
        <span>{{ $t("Quotations.actions.cancel") }}</span>
      </v-tooltip>
    </v-sheet>

    <!-- 弹窗 -->
    <DialogDelete
      v-model="cancelAlert"
      cancel-mode
      :label="$t('Quotations.ObjectName')"
      :code="quotation.quotation_code"
      @confirm="doAction('cancel')"
    />
  </div>
</template>

<script>
import DialogDelete from "@/components/plugins/DialogDelete";
import Quotations from "@/api/quotations";

export default {
  name: "QuotationsActions",

  props: {
    detailMode: Boolean,
    quotation: Object,
    showView: Boolean,
    showConfirm: Boolean,
    showApprove: Boolean,
    showCancel: Boolean,
  },
  components: {
    DialogDelete,
  },
  data: () => ({
    cancelAlert: false,
  }),

  methods: {
    actionMethod(mode) {
      if (mode == "cancel") return Quotations.cancel(this.quotation.id);
    },
    // 操作
    doAction(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          this.actionMethod(mode).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.$emit("done");
              }
            }.bind(this)
          );
        }.bind(this)
      );
    },
  },
};
</script>